import React, { useState } from 'react';
import eventlocation from "../../../assets/img/event-date.svg"
import eventdate from "../../../assets/img/event-location.svg"
import contimg from "../../../assets/img/contact-svgrepo-com 1.svg"
import faq from "../../../assets/img/help-circle.svg"
import community1 from "../../../assets/img/profile/communiy2.svg"
import downarrows from "../../../assets/img/dropdown.svg"
import l2 from "../../../assets/img/l2.svg"
import profile from "../../../assets/img/user-profile.svg"
import { Link } from "react-router-dom";
import ProfileCommunity from '../../Profile/ProfileCommunity';
import { Button, Modal } from 'react-bootstrap';
import { API } from '../../../services/api';
const EventAbout = ({ community, details }) => {
    const Group = require("../../../assets/img/Featured icon.jpg");
    const communityDetails = JSON.parse(localStorage.getItem('communityData'));
    const [isseventabout, setIsseventabout] = useState(false);
    const [iseventabouttwo, setIsSeventAboutTwo] = useState(false);
    const [isBreastCan, setIsBreastCan] = useState(false);
    const [isOtherLinksOpen, setIsOtherLinksOpen] = useState(true);
    const [isCommunity, setIsCommunity] = useState(false);
    const handleCommunityClose = () => setIsCommunity(false);
    return (

        <div className="rightbar mt-4">
            <div className='about-content border-bottom'>
                <h4 className='rightbar-heading' >description</h4>
                <p className='rightbar-descr' >{details?.eventShortDescription}
                 </p>               

                <h4 className='rightbar-heading' >Host</h4>
                <div className='host_sections'>
                     {details?.userId?.profileImage ? <img src={details?.userId?.profileSettings?.isPrivateProfile ? profile : API.uploadFilePath+details?.userId?.profileImage?.url } className="hostimage"></img>:
                     <img src={profile } className="hostimage"></img>}
                     {details?.userId?.userType === "individual"  ? <span className='hostname' >{details?.userId?.firstName + " " + details?.userId?.lastName}</span> :
                     <span className='hostname' >{details?.userId?.firstName}</span>}
                </div>

                
               
                <div class="side-menus-itm-dh mt-2">
                    <button
                        className="main-menu-itm-dh mt-default"
                        type="button"
                        onClick={() => setIsOtherLinksOpen(!isOtherLinksOpen)}
                    >
                        <span>Communities </span>
                       
                    </button>
                    {isOtherLinksOpen &&
                        <ul class="otherlinks">

                            <li className="">
                                <Link class="dropdown-item" href="#">
                                    {community?.slice(0, 2).map((community, index) => (
                                        <button className="join-btn-dh" type="button" onClick={() => { setIsseventabout(!isseventabout) }}>
                                           
                                            <div className="d-flex align-items-center gap-2">
                                                <img src={community?.profileImage?.url ? API.uploadFilePath + community?.profileImage?.url : community1} alt="icon" className="side-dh-com-thumb" />
                                                <span className="community-name-dh text-truncate">{community?.communityName}</span>
                                            </div>

                                        </button>
                                    ))}
                                </Link>
                            </li>
                        </ul>
                    }

                </div>
                {community?.length > 2 &&
                    <div className="container my-2">
                        <div className="d-flex justify-content-between align-items-center pb-1">
                            <Link className="see-more text-teal fw-semibold text-decoration-none" onClick={() => setIsCommunity(true)}>
                                See more...
                            </Link>
                        </div>
                    </div>}
               
            </div>
            <Modal show={isCommunity} onHide={handleCommunityClose} dialogClassName="custom-modal">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div>
                            <img src={Group} className="singupimage"></img>

                        </div>
                        <div className="header">
                            <h4 className="modal-tittle" >Community</h4>
                        </div>
                    </div>

                </Modal.Header>
                <Modal.Body>
                    <ul className="profile-community d-flex flex-wrap p-0 m-0">
                        {community?.map((community, index) => (
                            <li className="community-list-itm" >
                                <img src={community?.profileImage?.url ? API.uploadFilePath + community?.profileImage?.url : community1} alt="test" className="community_thumb" />
                                <span>{community?.communityName}</span>
                            </li>))}
                    </ul>

                </Modal.Body>
                <Modal.Footer className="modal-center" >
                    <Button variant="secondary" className="pop-primary" onClick={handleCommunityClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>

    );


};
export default EventAbout;